import gql from 'graphql-tag'

import { famVideo } from './Video'
import { famIngredientRecipe } from './IngredientRecipe'
import { famIngredientStep } from './IngredientStep'

export const famRecipe = gql`
  fragment famRecipe on Recipe {
    id
    name
    slug
    preparation_time
    baking_time
    rest_time
    benefits
    portions
    min_portions
    max_portions
    main_component
    unbreakable
    image
    image_alt
    cover_desktop
    cover_mobile
    cover_alt
    video {
      ...famVideo
    }
    publication_platforms
    published
    archived
    recipe_category
    ranking
    seasons
    express
    nutriscore
    kcal_per_100_g
    kj_per_100_g
    lipids_per_100_g
    saturated_fatty_acids_per_100_g
    carbohydrates_per_100_g
    simple_sugars_per_100_g
    fibres_per_100_g
    salt_per_100_g
    pnns_fruit_per_100_g
    pnns_vegetable_per_100_g
    oils_per_100_g
    pnns_nuts_per_100_g
    pnns_dried_vegetable_per_100_g
    proteins_per_100_g
    family_recipe
    parent
    tags {
      name
      type
    }
    steps {
      order
      text
      image
      image_alt
      family_profile
      video {
        ...famVideo
      }
      ingredients {
        ...famIngredientStep
      }
    }
    ingredients {
      ...famIngredientRecipe
    }
    children_recipes {
      id
      slug
      name
      image
      recipe_category
      ranking
      steps {
        order
        text
        image
        image_alt
        family_profile
        video {
          ...famVideo
        }
        ingredients {
          ...famIngredientStep
        }
      }
    }
  }
  ${famIngredientStep}
  ${famIngredientRecipe}
  ${famVideo}
`
